import React, { useState } from 'react';
import Modal from '@mui/material/Modal';
import { Box, Button, Grid, TextField } from '@mui/material';
import axios from 'axios';

const NewDataModal = (props) => {
    const [formData, setFormData] = useState({
        locationTrackingCode: '',
        uniqueBoxBarcode: '',
        department: '',
        client: '',
        documentType: '',
        boxCode: '',
        boxSequenceStart: '',
        boxSequenceStop: '',
        dateFrom: '',
        dateTo: '',
        handoverDate: ''
    });


    const resetForm=()=>{
        setFormData({
            locationTrackingCode: '',
            uniqueBoxBarcode: '',
            department: '',
            client: '',
            documentType: '',
            boxCode: '',
            boxSequenceStart: '',
            boxSequenceStop: '',
            dateFrom: '',
            dateTo: '',
            handoverDate: ''
        })
    }

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            let config = {
                method: 'post',
                data:formData,
                url: '/api/data-entry/',
                headers: { 'Authorization': `Bearer ${props.accessToken}` }
            };
            const response = await axios.request(config);
          
            props.fetchData()
            resetForm()
            props.onClose()
            // Handle success here
        } catch (error) {
            console.error('Error:', error);
            // Handle error here
        }
    };
    return (
        <Modal
            open={props.isOpen}
            onClose={props.onClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }}
        >
            <Box
                sx={{
                    width: 600, // Adjust the width as needed
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    p: 2,
                    overflow: 'auto' // Enable scrolling when necessary
                }}
            >
                <form onSubmit={handleSubmit}>
                    <h5 className='p-3 text-center'>NEW DATA ENTRY</h5>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={6}>
                            <TextField
                                fullWidth
                                label="Location Tracking Code"
                                name="locationTrackingCode"
                                value={formData.locationTrackingCode}
                                onChange={handleInputChange}
                                size="small"
                                required
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <TextField
                                fullWidth
                                label="Unique Box Barcode"
                                name="uniqueBoxBarcode"
                                value={formData.uniqueBoxBarcode}
                                onChange={handleInputChange}
                                size="small"
                                required
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <TextField
                                fullWidth
                                label="Department"
                                name="department"
                                value={formData.department}
                                onChange={handleInputChange}
                                size="small"
                                required
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <TextField
                                fullWidth
                                label="Client"
                                name="client"
                                value={formData.client}
                                onChange={handleInputChange}
                                size="small"
                                required
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <TextField
                                fullWidth
                                label="Document Type"
                                name="documentType"
                                value={formData.documentType}
                                onChange={handleInputChange}
                                size="small"
                                required
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <TextField
                                fullWidth
                                label="Box Code"
                                name="boxCode"
                                value={formData.boxCode}
                                onChange={handleInputChange}
                                size="small"
                                required
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <TextField
                                fullWidth
                                label="Box Sequence Start"
                                name="boxSequenceStart"
                                value={formData.boxSequenceStart}
                                onChange={handleInputChange}
                                size="small"
                                required
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <TextField
                                fullWidth
                                label="Box Sequence Stop"
                                name="boxSequenceStop"
                                value={formData.boxSequenceStop}
                                onChange={handleInputChange}
                                size="small"
                                required
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <TextField
                                fullWidth
                                label="Date From"
                                type="date"  // Change the type to 'date'
                                name="dateFrom"
                                value={formData.dateFrom}
                                onChange={handleInputChange}
                                InputLabelProps={{
                                    shrink: true,  // Ensure the label shrinks when a date is selected
                                }}
                                size="small"
                                required
                            />

                        </Grid>
                        <Grid item xs={12} md={6}>
                            <TextField
                                fullWidth
                                label="Date To"
                                type="date"  // Change the type to 'date'
                                name="dateTo"
                                value={formData.dateTo}
                                onChange={handleInputChange}
                                InputLabelProps={{
                                    shrink: true,  // Ensure the label shrinks when a date is selected
                                }}
                                size="small"
                                required
                            />

                        </Grid>
                        <Grid item xs={12} md={6}>
                            <TextField
                                fullWidth
                                label="Handover Date"
                                type="date"  // Change the type to 'date'
                                name="handoverDate"
                                value={formData.handoverDate}
                                onChange={handleInputChange}
                                InputLabelProps={{
                                    shrink: true,  // Ensure the label shrinks when a date is selected
                                }}
                                size="small"
                                required
                            />
                        </Grid>
                    </Grid>
                    <div className='text-center p-2 '>
                        <Button className='mx-2 my-2' type="submit" variant="contained" color="success">Submit New Entry</Button>
                   
                        <Button onClick={props.onClose} className='mx-2  my-2' variant="contained" color="warning">Cancel</Button>
                        <Button size='small' onClick={resetForm} className='mx-2  my-2' variant="contained" >Clear</Button>
                      
                        
                    </div>
                </form>
            </Box>
        </Modal>
    );
};

export default NewDataModal;
